export default "__VITE_ASSET__0gsyLRkX1CxS7OUl3Luoew__"